// extracted by mini-css-extract-plugin
module.exports = {"color":"color___2vwrF","is-selected":"is-selected___3qltk"};